import React from "react";
import PropTypes from "prop-types";
import { Grid, Box } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";

const OBJECT_IDS = {
  COBERTURA_BASE_TABLE: "686e7c32-5326-4c63-b343-296cdd6b3b9f",
};

const RankingUF = ({ app, objectId }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card
        app={app}
        className={"card-kpi-item"}
        header={{ hardTitle: "Ranking por UF" }}
      >
        <NativeObject
          app={app}
          key={objectId || OBJECT_IDS.COBERTURA_BASE_TABLE}
          style={{ width: "100%", height: "50vh" }}
          reference={{ id: objectId || OBJECT_IDS.COBERTURA_BASE_TABLE }}
          className={"table-item-ranking"}
        />
        <Grid container spacing={2} sx={{marginTop: "15px", justifyContent: "center"}}>
          <Grid item sx={{display: "flex", justifyContent: "center"}}>
            <Box
              sx={{
                width: 12,
                height: 12,
                bgcolor: "#1E276D",
                mr: 1,
                borderRadius: "2px",
              }}
            />
            <span style={{fontSize: "12px", fontWeight: "400", fontFamily: "Lato"}}>PDVS CARTEIRA</span>
          </Grid>
          <Grid item sx={{display: "flex", justifyContent: "center"}}>
          <Box
              sx={{
                width: 12,
                height: 12,
                bgcolor: "#BBC2FB",
                mr: 1,
                borderRadius: "2px",
              }}
            />
            <span style={{fontSize: "12px", fontWeight: "400", fontFamily: "Lato"}}>PDVS COMPRADORES</span>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

RankingUF.propTypes = {
  app: PropTypes.object.isRequired,
  objectId: PropTypes.string,
};

export default RankingUF;

